import styled from 'styled-components'

export const PlanCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 12rem;
`

export const PlanCode = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 0.75rem;
  color: ${(p) => p.theme.textFaded};
`

export const TargetCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 10rem;
`

export const ProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  background: ${(p) => p.theme.tableRowBorder};
  border-radius: 2px;
  overflow: hidden;
`

export const ProgressFill = styled.div`
  height: 100%;
  background: ${(p) => p.theme.colorOrange};
  border-radius: 2px;
`

interface OwnerBadgeProps {
  $tokenKey: string
}

export const OwnerInitialsBadge = styled.div<OwnerBadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.7rem;
  color: ${(p) => p.theme.colorWhite};
  background: ${(p) => {
    const themeRecord = p.theme as unknown as Record<string, string>
    return themeRecord[p.$tokenKey] ?? themeRecord.textFaded
  }};
`

export const QueueHealthChip = styled.span<{ $tone: 'ok' | 'warning' | 'danger' }>`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  border: 1px solid
    ${({ $tone, theme }) =>
    $tone === 'danger'
      ? theme.colorRed
      : $tone === 'warning'
        ? theme.warningColor
        : theme.colorGreen};
  background: ${({ $tone, theme }) =>
    `${$tone === 'danger'
      ? theme.colorRed
      : $tone === 'warning'
        ? theme.warningColor
        : theme.colorGreen
    }22`};
  color: ${({ $tone, theme }) =>
    $tone === 'danger'
      ? theme.colorRed
      : $tone === 'warning'
        ? theme.warningColor
        : theme.colorGreen};
`

export const StatusBadge = styled.span<{ hexColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  background-color: ${(p) => p.hexColor};
  color: #fff;
  width: fit-content;
`


export const SandboxPreview = styled.div`

  margin-top: 1rem;
  width: 100%;
  padding: 1rem;
  border: 1px solid ${(p) => p.theme.colorDividerDefault};
  border-radius: 0.5rem;

`

export const AddPhaseSection = styled.div`
  margin-top: 1rem;
  border: 1px dashed #ff9900;
  border-radius: 0.5rem;
  padding: 1rem;

`

export const NotYetAdded = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px dashed ${props => props.theme.colorDividerDefault};
  border-radius: 0.5rem;
  padding: 1rem;
`